const isObjectEmpty = obj => {
  const { length } = Object.keys(obj);
  return length === 0;
};
export default isObjectEmpty;
